import { render, staticRenderFns } from "./MyProvisioning.vue?vue&type=template&id=c2d4bb32&scoped=true&"
import script from "./MyProvisioning.vue?vue&type=script&lang=js&"
export * from "./MyProvisioning.vue?vue&type=script&lang=js&"
import style0 from "./MyProvisioning.vue?vue&type=style&index=0&id=c2d4bb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d4bb32",
  null
  
)

export default component.exports